/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { statementsGet } from "../../funcs/statementsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetStatementRequest$inboundSchema,
};

export const tool$statementsGet: ToolDefinition<typeof args> = {
  name: "statements-get",
  description: `Retrieve a statement by its ID.

Use the \`Accept\` header to specify the format of the response. Supported formats are \`application/json\` and \`application/pdf\`.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/)
you'll need to specify the \`/accounts/{accountID}/profile.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await statementsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
